import { useEffect, useState } from 'react';

import { useAppSelector } from '../redux/hooks';
import { selectCustomDensity } from '../redux/slices/utils-slice';
import { getCleanPathname } from '../utils/clean-routes-utils';
import { gdRoutes } from '../utils/gdRoutes';
import { useConnectedRouter } from './useConnectedRouter';

export const useCheckForScrollableSidebarMenu = () => {
  const [shouldSidebarMenuBeScrollable, setShouldSidebarMenuBeScrollable] = useState(false);

  const customDensity = useAppSelector(selectCustomDensity);
  const router = useConnectedRouter();

  useEffect(() => {
    const isHomePage = getCleanPathname(router.pathname) === gdRoutes.home;
    const isCardDensity = customDensity === 'card';
    setShouldSidebarMenuBeScrollable(isHomePage && isCardDensity);
  }, [customDensity, router.pathname]);

  return { shouldSidebarMenuBeScrollable };
};
